// frontend/src/voicechat/WebRTC.noop.js
// No-op implementation to temporarily disable voice chat without breaking imports
export const useOptimizedWebRTC = () => {
  return {
    // State
    isInitializing: false,
    isSupported: false,
    supportFeatures: {},
    // Methods
    initializeWebRTC: async () => null,
    enableVoiceChat: async () => null,
    disableVoiceChat: () => null,
    toggleMic: async () => null,
    handleRoomStateUpdate: () => null,
    // Utils
    getManager: () => null,
    isInitialized: () => false,
  };
};

export default useOptimizedWebRTC;
